import { useApi } from './use-api-call';
import { ProductDTO } from './product-api';
import { api } from './api';
import { apiConfig } from './config';
export const useSearchLicenseCodeApi = () =>
    useApi<{
        licenseCodes: LicenseCodeDTO[];
        allowEdit: boolean;
        products: ProductDTO[];
    }>('/license-code/search-license-code');

export const useFilterLicenseCodesApi = () =>
    useApi<{
        licenseCodes: LicenseCodeDTO[];
        totalCount: number;
        pageSize: number;
        pageIndex: number;
    }>('/license-code/filter-license-codes');

export const useInitDownloadableLicenseCodesApi = () =>
    useApi<{ liceenseCodes: { productId: number; count: number }[] }>(
        '/license-code/init-downloadable-license-codes'
    );

export const useInitDownloadableLicenseCodesByProductIdApi = () =>
    useApi<{ liceenseCodes: { productId: number; count: number }[] }>(
        '/license-code/init-downloadable-license-codes/{productId}'
    );

export const downloadLicenseCode = (code: string) =>
    api.call('get', apiConfig.licenseCodeUrl + `/download-license-code/${code}`);

export const useGetLicenseCodeApi = () =>
    useApi<{ licenseCode: LicenseCodeDTO; allowEdit: boolean }>(
        '/license-code/get-license-code/{serial}'
    );

export const useSaveLicenseCodeApi = () =>
    useApi<{ licenseCode: LicenseCodeDTO }>('/license-code/save-license-code');

export const useGenerateCodeApi = () => useApi<{ code: string }>('/license-code/generate-code');

export const useDeleteLicenseCodeApi = () => useApi('/license-code/delete-license-code/{serial}');

export const useGenerateLicenseCodesApi = () =>
    useApi<{ licenseCodes: LicenseCodeDTO[] }>('/license-code/generate-license-codes');

export const requestDownloadLicenseCodesApi = (data: any) =>
    api.call('post', apiConfig.licenseCodeUrl + '/request-download-license-codes', data);

export interface LicenseCodeDTO {
    serial: number;
    code: string;
    productId: number;
    downloaded: boolean;
    batchNumber?: string;
    createdAt?: Date;
    createdBy?: string;
    modifiedAt?: Date;
    modifiedBy?: string;
}
